import {createClient} from 'next-sanity';

import {apiVersion, dataset, projectId} from './api';

export const client = createClient({
	projectId,
	dataset,
	apiVersion,
	useCdn: false,
	// Stega wraps values in some kind of proxy object that doesn't properly compare against
	// string literals. This is especially problematic when comparing with type equality (===),
	// which most developers have been conditioned to do. This issue breaks a lot of our Tailwind
	// styling where we compare sanity values against string literals, for  instance for content
	// block spacing or the gallery aspect ratio. We don't use Presentation, so we can just
	// disable Stega.
	stega: false,
});
